<template>
  <div class="main-wrapper scroll-y custom-scrollbar view-auth">

    <svg class="logo">
      <use xlink:href="#portalgastro-logo"></use>
    </svg>

    <form-register-details></form-register-details>

  </div>
</template>

<script>
  import FormRegisterDetails from '@/forms/register/FormRegisterDetails';

  export default {
    name: 'RegisterDetails',
    components: { FormRegisterDetails }
  }
</script>